import React, { CSSProperties } from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const ImgComponent: MyComponentType<Props> = (props: Props) => {
  const { id, styles, privateSchema } = props;

  return (
    <div id={id}>
      <img
        style={{
          width:
            privateSchema?.src?.[0]?.aspectRatio < 1
              ? `${parseInt(`${styles?.width ?? 100}`, 10) / privateSchema?.src?.[0]?.aspectRatio}%`
              : '100%',
          borderRadius: '5px',
        }}
        src={`${
          // eslint-disable-next-line max-len
          privateSchema?.src?.[0]?.mediaSrc ||
          props.config.src ||
          'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800'
        }?image_process=resize,w_1200/quality,Q_80/format,webp`}
        alt={privateSchema?.src?.[0]?.alt}
      />
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/ImgComponentDefinition'));

const computeStyle = (componentConfig: ElementConfigType) => {
  const { styles, privateSchema, parentNodeIsBody } = componentConfig;
  const initStyle = parentNodeIsBody
    ? {
        width: '100%',
        display: 'block',
        paddingTop: 16,
        paddingBottom: privateSchema?.src?.[0]?.aspectRatio
          ? `${parseInt(`${styles?.width ?? 100}`, 10) / privateSchema?.src?.[0]?.aspectRatio}%`
          : 0,
        height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
        marginBottom: 16,
      }
    : {
        width: '100%',
        display: 'block',
        paddingBottom: privateSchema?.src?.[0]?.aspectRatio
          ? `${parseInt(`${styles?.width ?? 100}`, 10) / privateSchema?.src?.[0]?.aspectRatio}%`
          : 0,
        height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
      };
  return initStyle;
};

ImgComponent.definition = {
  id: ComponentIdEnum.IMG_COMPONENT,
  name: '图片组件_1',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_200',
  position: 8, // 显示顺序
  config: {
    text: '这是一个图片容器',
    src: 'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800',
  },
  styles: {
    width: '100%',
  },
  privateSchema: {},
  computeStyle,
  category: 'media',
  configForm: ConfigHOC(ConfigForm),
};
